import React from 'react';
import { Route } from '../Routing/types';
import {
  LabTestsIndexPage,
  LabTestsAddPage,
  LabTestsEditPage,
  LabTestsHistoryPage,
} from '@front-activerse/modules';

const descendantRoutes: Route[] = [
  {
    path: '/',
    element: <LabTestsIndexPage />,
    private: true,
    title: 'labTests.navbarTitle',
    mobileAppTabIdentifier: 'diary',
  },
  {
    path: '/add',
    element: <LabTestsAddPage />,
    private: true,
    title: 'addTestResults.navbarTitle',
    mobileAppTabIdentifier: 'diary',
  },
  {
    path: '/history/:category',
    element: <LabTestsHistoryPage />,
    private: true,
    title: 'labTestsHistory.navbarTitle',
    mobileAppTabIdentifier: 'diary',
  },
  {
    path: '/edit',
    element: <LabTestsEditPage />,
    private: true,
    title: 'testResultsEditing.navbarTitle',
    mobileAppTabIdentifier: 'diary',
  },
];

export default descendantRoutes;
